import { Pagination, ProductCard } from "@components";
import { AddProductInBasketType, Basket, Product, ProductPagination } from "@utilities/types";
import { FC } from "react";

interface Props {
    productsPagination: ProductPagination | null;
    products: Product[];
    categoryName: string;
    basket: Basket | null;
    handleChangePage: (page: number) => void;
    onAddProductInBasket: (basketElement: Partial<AddProductInBasketType>)=> void;
    onRemoveProductInBasket: (basketElement: AddProductInBasketType)=> void;
}

export const ProductList: FC<Props> = ({
    productsPagination,
    products,
    categoryName,
    basket,
    handleChangePage,
    onAddProductInBasket,
    onRemoveProductInBasket,
}) => {

    return (
        <div className="container mx-auto">
            <div className="text-lg font-semibold text-gray-800">
                {categoryName}
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 pt-4 pb-4">
                {
                    products.length > 0 ? (
                        products.map((product, i) => (
                            <ProductCard 
                                key={i}
                                product={product}
                                basket={basket}
                                onAddProduct={onAddProductInBasket}
                                onRemoveProduct={onRemoveProductInBasket}
                            />
                        ))
                    ) : (
                        <div className="col-span-full text-center text-gray-500 text-lg md:text-3xl">
                            <p>Aucun produit trouvé</p>
                        </div>
                    )
                }
            </div>

            {
                productsPagination && (
                    <Pagination
                        currentPage={productsPagination.currentPage}
                        totalPages={productsPagination.totalPages}
                        onPageChange={handleChangePage}
                    />
                )
            }
        </div>
    );
};
